import React from 'react';

function OurExpertise() {
    return (
        <div>
            <div className="mx-auto text-center md:py-2">
                <section
                    className="w-full bg-cover bg-center bg-no-repeat bg-white text-gray-700 rounded-lg py-2 md:py-16">
                    <div className="gap-6 items-center md:py-3">
                        <div className="p-2 md:p-2 rounded-lg">
                            <h2 className="text-3xl md:text-4xl font-bold py-2">EXPLORE DIVISIONS</h2>
                            <p className="sm:p-4 md:p-2 rounded-lg text-lg md:text-2xl">
                                At AKT, we specialize in providing tailored solutions across a wide range of industries. Whether it's automotive, steel, or trading products such as glazing, coatings,
                                adhesives, and industrial sales, our divisions are committed to enhancing efficiency, elevating performance, and ensuring safety. Explore how each of our divisions
                                empowers industries to thrive in an ever-evolving world.
                            </p>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default OurExpertise;
